import { useEffect } from 'react';
import { message as antdMessage } from 'antd';
import { useAppDispatch, useAppSelector } from '../../hooks/store';
import { clearMessages } from '../../store/slices/message';

const MessageHandler = () => {
    const dispatch = useAppDispatch();
    const [messageApi, contextHolder] = antdMessage.useMessage();

    const { errorMessages, infoMessages, warningMessages } = useAppSelector((state) => state.message);

    useEffect(() => {
        const allMessages = [
            ...errorMessages.map((msg) => ({ ...msg, type: 'error' as const })),
            ...infoMessages.map((msg) => ({ ...msg, type: 'info' as const })),
            ...warningMessages.map((msg) => ({ ...msg, type: 'warning' as const })),
        ];

        if (allMessages.length === 0) return;

        const idsToClear: number[] = [];

        allMessages.forEach(({ id, text, type }) => {
            messageApi[type](text);
            idsToClear.push(id);
        });

        dispatch(clearMessages(idsToClear));
    }, [errorMessages, infoMessages, warningMessages, messageApi, dispatch]);

    return contextHolder;
};

export default MessageHandler;
